export enum ProfileStatus {
  start = "start",
  draft = "draft",
  submitted = "submitted",
  fileChecked = "fileChecked",
  fileRejected = "fileRejected",
  fileLated = "fileLated",
  invitedToInterview = "invitedToInterview",
  notInvitedToInterview = "notInvitedToInterview",
  passedInterview = "passedInterview",
  failedInterview = "failedInterview",
  waitingAvailabilityResponse = "waitingAvailabilityResponse",
  acceptedAvailabilityResponse = "acceptedAvailabilityResponse",
  rejectedAvailabilityResponse = "rejectedAvailabilityResponse",
  paymentAccepted = "paymentAccepted",
  paymentFailed = "paymentFailed",
  passedTheCamp = "passedTheCamp"
}
